export default "__VITE_ASSET__CIWqxfTs__"